import * as requestFromServer from "./authApiCall";
import { authSlice, callTypes } from "./authSlice";

const { actions } = authSlice;

export const login = (queryParams: any) => (dispatch: any) => {
  dispatch(actions.loggedin({ isAuth: true }));
  // dispatch(actions.startCall({ callType: callTypes.list }));
  // return requestFromServer
  //   .login(queryParams)
  //   .then(response => {
  //     const { totalCount, success, data } = response.data;
  //     dispatch(actions({ totalCount, success, data }));
  //   })
  //   .catch(error => {
  //     error.clientMessage = "Can't find customers";
  //     dispatch(actions.catchError({ error, callType: callTypes.list }));
  //   });
};

export const signOut = (queryParams: any) => (dispatch: any) => {
  dispatch(actions.signedOut({ isAuth: false }));
};
